// extracted by mini-css-extract-plugin
export default {"root":"n8oAm","myMessage":"A1imD","firstInGroup":"sHVzw","lastInGroup":"S8fAr","mobile":"k4LU3","smallMobile":"X4Xj9"};